export default __webpack_public_path__ + "media/music/f470dae906e5e0139d5a35b8a232e9b9.mp3";